import { TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH, CHANGE_LAYOUT_TYPE } from './actionTypes'
import { NAV_STYLE } from './constants'

export function toggleCollapsedSideNav(navCollapsed) {
    return { type: TOGGLE_COLLAPSED_NAV, navCollapsed }
}

export function updateWindowWidth(width) {
    return { type: WINDOW_WIDTH, width }
}

export function onNavStyleChange(navStyle) {
    return { type: NAV_STYLE, navStyle }
}

export function changeRoute(pathname) {
    return { type: '@@router/LOCATION_CHANGE', pathname }
}

export function changeLayoutType(layoutType) {
    return { type: CHANGE_LAYOUT_TYPE, layoutType }
}
